import React, { useEffect, useMemo } from 'react';
import isEqual from 'lodash/isEqual';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid-old';
import { Link } from '@yme/components/Link';
import { useWindowSize } from '@yme/hooks/index';
import { LanguageSelector } from '@yme/molecules/language-selector';
import { getCountries, getCurrentCountryRoot, getIsNewsletterSubscriptionEnabled, getRTL, } from '@yme/selectors/common';
import { DigitalDataMutation, buildKey, filterNotSupCountries, setDigitalData, } from '@yme/utils/common';
import { Newsletters } from '../Footer/Newsletters';
import { SocialIcons } from '../Footer/SocialIcons';
import { FooterBottomStyled, MiddleSectionStyled, RightSectionStyled } from './FooterBottomStyled';
import { setCountryList } from './redux/actions';
import { getFooterContent } from './redux/selectors';
function FooterBottomMenu(props) {
    const { copyrightNotice, countries, links, labels } = props;
    const dispatch = useDispatch();
    const currentCountry = useSelector(getCurrentCountryRoot);
    const filteredCountries = useMemo(() => filterNotSupCountries(countries, currentCountry), [countries, currentCountry]);
    const { isMobileView, isTabletView } = useWindowSize();
    const isRightToLeft = useSelector(getRTL);
    const { socialLinks } = useSelector(getFooterContent);
    const currentCountries = useSelector(getCountries);
    const isNewsletterSubscriptionEnabled = useSelector(getIsNewsletterSubscriptionEnabled);
    useEffect(() => {
        if (isEqual(currentCountries, filteredCountries))
            return;
        dispatch(setCountryList(filteredCountries));
    }, [filteredCountries, currentCountries, dispatch]);
    return props ? (React.createElement(FooterBottomStyled, { isRightToLeft: isRightToLeft },
        React.createElement(Container, { xxlPadding: "52px 48px 32px 48px" },
            React.createElement(Row, null,
                (isMobileView || isTabletView) && isNewsletterSubscriptionEnabled ? (React.createElement(Col, { lg: 12 },
                    React.createElement(Newsletters, null))) : null,
                React.createElement(Col, { xxl: 3, lg: 4, sm: 12, lgOrder: 1 },
                    React.createElement(LanguageSelector, { labels: labels, countries: filteredCountries })),
                isMobileView || isTabletView ? (React.createElement(Col, { lg: 8, sm: 12, lgOrder: 2, lgPadding: "0", smPadding: "0px 4px" },
                    React.createElement(SocialIcons, { socialLinks: socialLinks }))) : null,
                React.createElement(Col, { xxl: 6, lg: 12, sm: 12, lgOrder: 3, smOrder: 3, smPadding: "24px 4px 0px 4px" },
                    React.createElement(MiddleSectionStyled, null, copyrightNotice)),
                React.createElement(Col, { xxl: 3, lg: 12, sm: 12, lgOrder: 4, smOrder: 4, lgPadding: "24px 0", smPadding: "32px 4px 0px 4px" },
                    React.createElement(RightSectionStyled, null, links.map(({ linkTitle, link, linkTitleMaster }, i) => (React.createElement(Link, { to: link, key: buildKey(i, linkTitle), 
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick: () => {
                            setDigitalData(DigitalDataMutation.NAVIGATION, {
                                pageSection: 'footer',
                                navigationGroup: '',
                                navigationItem: linkTitleMaster || linkTitle,
                            });
                        } }, linkTitle))))))))) : null;
}
export default FooterBottomMenu;
